import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { ssListItem } from 'app/components/global';
import controller from './pandemic-plan-procedure.controller';
import directive from './pandemic-plan-procedure.directive';

export default angular.module('app.components.advisory.bcp.pandemicPlanProcedure', [
  bcpDataService,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  ssListItem,
])
  .directive('bcpPandemicPlanProcedure', directive)
  .controller('PandemicPlanProcedureController', controller)
  .name;

console.log('app.components.advisory.bcp.pandemicPlanProcedure created');
